import Vue from 'vue';
import Parse from 'parse';
import Router from 'vue-router';

import ROUTENAMES from '../config/navigation/route-names';

import MainPage from '../pages/MainPage';
import LoginPage from '../pages/LoginPage';
import DashboardPage from '../pages/dashboard/DashboardPage';
import CatalogPage from '../pages/catalog/CatalogPage';
import ProductViewPage from '../pages/catalog/products/ProductViewPage';
import SystemViewPage from '../pages/catalog/systems/SystemViewPage';
import SystemApplicationsPage from '../pages/system-applications/SystemApplicationsPage';
import CartOverviewPage from '../pages/cart/CartOverviewPage';
import MyAccountPage from '../pages/account/MyAccountPage';
import RegisterPage from '../pages/RegisterPage';
import CheckoutMainPage from '../pages/checkout/CheckoutMainPage';
import CheckoutTypePage from '../pages/checkout/CheckoutTypePage';
import CheckoutSummaryPage from '../pages/checkout/CheckoutSummaryPage';
import CheckoutDetailsPage from '../pages/checkout/CheckoutDetailsPage';
import QRScanPage from '../pages/qrscanner/QRScanPage';
import ProductsCatalogPage from '../pages/catalog/products/ProductsCatalogPage';
import SystemsCatalogPage from '../pages/catalog/systems/SystemsCatalogPage';
import AllCartOrdersRequestsPage from '../pages/account/history/AllCartOrdersRequestsPage';
import PasswordForgotPage from '../pages/password-reset/PasswordForgotPage';
import PasswordResetPage from '../pages/password-reset/PasswordResetPage';
import OrderDetailPage from '../pages/account/history/order/OrderDetailPage';
import RequestDetailPage from '../pages/account/history/request/RequestDetailPage';

//Admin Pages
import AdminPage from '../pages/admin/AdminPage';
import AdminDashboardPage from '../pages/admin/dashboard/AdminDashboardPage';
import AdminUserRequestsPage from '../pages/admin/user-requests/AdminUserRequestsPage';
import AdminGeneralConfigPage from '../pages/admin/general-config/AdminGeneralConfigPage';
import AdminUserPage from '../pages/admin/user/AdminUserPage';
import AdminOrderPage from '../pages/admin/order/AdminOrderPage';
import AdminRequestPage from '../pages/admin/request/AdminRequestPage';
import AdminOrderDetailPage from '../pages/admin/order/AdminOrderDetailPage';
import AdminRequestDetailPage from '../pages/admin/request/AdminRequestDetailPage';
import QCVMixerPage from '../pages/qcv-mixer/QCVMixerPage';
import ElasticMixerPage from '../pages/elastic-mixer/ElasticMixerPage';
import AdminMixerRequestsPage from '../pages/admin/mixer-requests/AdminMixerRequestsPage';
import AdminMixerRequestDetailPage from '../pages/admin/mixer-requests/AdminMixerRequestDetailPage';
import AdminUserDetailPage from '../pages/admin/user/AdminUserDetailPage';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: '/',
      name: ROUTENAMES.MAIN_PAGE_ROUTE,
      component: MainPage,
      redirect: '/dashboard',
      beforeEnter: requireAuth,
      children: [
        {
          path: 'dashboard',
          name: ROUTENAMES.DASHBOARD_PAGE_ROUTE,
          component: DashboardPage,
        },
        {
          path: 'account',
          name: ROUTENAMES.MY_ACCOUNT_PAGE_ROUTE,
          component: MyAccountPage,
        },
        {
          path: 'account/history/:checkoutType',
          name: ROUTENAMES.ALL_CART_ORDERSREQUESTS_PAGE_ROUTE,
          component: AllCartOrdersRequestsPage,
        },
        {
          path: 'account/history/order/:id',
          name: ROUTENAMES.ORDER_DETAIL_PAGE_ROUTE,
          component: OrderDetailPage,
        },
        {
          path: 'account/history/request/:id',
          name: ROUTENAMES.REQUEST_DETAIL_PAGE_ROUTE,
          component: RequestDetailPage,
        },

        {
          path: 'applications',
          name: ROUTENAMES.SYSTEM_APPLICATIONS_PAGE_ROUTE,
          component: SystemApplicationsPage,
        },
        {
          path: 'catalog',
          redirect: '/catalog/products',
          name: ROUTENAMES.CATALOG_PAGE_ROUTE,
          component: CatalogPage,
          children: [
            {
              path: 'products',
              name: ROUTENAMES.CATALOG_PRODUCTS_PAGE_ROUTE,
              component: ProductsCatalogPage,
            },
            {
              path: 'systems',
              name: ROUTENAMES.CATALOG_SYSTEMS_PAGE_ROUTE,
              component: SystemsCatalogPage,
            },
          ],
        },

        {
          path: 'cart',
          name: ROUTENAMES.CART_OVERVIEW_PAGE_ROUTE,
          component: CartOverviewPage,
        },
        {
          path: 'qcvmixer',
          name: ROUTENAMES.QCVMIXER_PAGE_ROUTE,
          component: QCVMixerPage,
        },
        {
          path: 'elasticmixer',
          name: ROUTENAMES.ELASTICMIXER_PAGE_ROUTE,
          component: ElasticMixerPage,
        },
        {
          path: 'qrscan',
          name: ROUTENAMES.QR_SCAN_PAGE_ROUTE,
          component: QRScanPage,
        },
        {
          path: 'catalog/products/:id',
          name: ROUTENAMES.PRODUCT_VIEW_PAGE_ROUTE,
          component: ProductViewPage,
        },
        {
          path: 'catalog/systems/:id',
          name: ROUTENAMES.SYSTEM_VIEW_PAGE_ROUTE,
          component: SystemViewPage,
        },
        {
          path: '/checkout',
          redirect: '/checkout/type',
          name: ROUTENAMES.CHECKOUT_MAIN_PAGE_ROUTE,
          component: CheckoutMainPage,
          children: [
            {
              path: 'type',
              name: ROUTENAMES.CHECKOUT_TYPE_PAGE_ROUTE,
              component: CheckoutTypePage,
            },
            {
              path: 'details',
              name: ROUTENAMES.CHECKOUT_DETAILS_PAGE_ROUTE,
              component: CheckoutDetailsPage,
            },
            {
              path: 'summary',
              name: ROUTENAMES.CHECKOUT_SUMMARY_PAGE_ROUTE,
              component: CheckoutSummaryPage,
            },
          ],
        },
      ],
    },
    {
      path: '/login',
      name: ROUTENAMES.LOGIN_PAGE_ROUTE,
      component: LoginPage,
      beforeEnter: isAuth,
    },
    {
      path: '/register',
      name: ROUTENAMES.REGISTER_PAGE_ROUTE,
      component: RegisterPage,
    },
    {
      path: '/forgot-password',
      name: ROUTENAMES.PASSWORD_FORGOT_PAGE_ROUTE,
      component: PasswordForgotPage,
    },
    {
      path: '/reset-password/:hash',
      name: ROUTENAMES.PASSWORD_RESET_PAGE_ROUTE,
      component: PasswordResetPage,
    },
    {
      path: '/admin',
      name: ROUTENAMES.ADMIN_PAGE_ROUTE,
      component: AdminPage,
      redirect: '/admin/dashboard',
      beforeEnter: requireAdmin,
      children: [
        {
          path: 'dashboard',
          name: ROUTENAMES.ADMIN_DASHBOARD_PAGE_ROUTE,
          component: AdminDashboardPage,
        },
        {
          path: 'user',
          name: ROUTENAMES.ADMIN_USER_PAGE_ROUTE,
          component: AdminUserPage,
        },
        {
          path: 'user/:id',
          name: ROUTENAMES.ADMIN_USER_DETAIL_PAGE_ROUTE,
          component: AdminUserDetailPage,
        },
        {
          path: 'orders',
          name: ROUTENAMES.ADMIN_ORDER_PAGE_ROUTE,
          component: AdminOrderPage,
        },
        {
          path: 'orders/:id',
          name: ROUTENAMES.ADMIN_ORDER_DETAIL_PAGE_ROUTE,
          component: AdminOrderDetailPage,
        },
        {
          path: 'requests',
          name: ROUTENAMES.ADMIN_REQUEST_PAGE_ROUTE,
          component: AdminRequestPage,
        },
        {
          path: 'requests/:id',
          name: ROUTENAMES.ADMIN_REQUEST_DETAIL_PAGE_ROUTE,
          component: AdminRequestDetailPage,
        },
        {
          path: 'mixer-requests',
          name: ROUTENAMES.ADMIN_MIXER_REQUEST_PAGE_ROUTE,
          component: AdminMixerRequestsPage,
        },
        {
          path: 'mixer-requests/:id',
          name: ROUTENAMES.ADMIN_MIXER_REQUEST_DETAIL_PAGE_ROUTE,
          component: AdminMixerRequestDetailPage,
        },
        {
          path: 'user-requests',
          name: ROUTENAMES.ADMIN_USER_REQUESTS_PAGE_ROUTE,
          component: AdminUserRequestsPage,
        },
        {
          path: 'general-config',
          name: ROUTENAMES.ADMIN_GENERAL_CONFIG_PAGE_ROUTE,
          component: AdminGeneralConfigPage,
        },
      ],
    },
  ],
});

function requireAuth(to, from, next) {
  if (!Parse.User.current()) {
    next({
      path: '/login',
    });
  } else next();
}

function isAuth(to, from, next) {
  if (Parse.User.current()) {
    next({
      path: '/',
    });
  } else next();
}

function isAdmin() {
  let adminRoleQuery = new Parse.Query(Parse.Role);
  adminRoleQuery.equalTo('name', 'Admin');
  adminRoleQuery.equalTo('users', Parse.User.current());
  return adminRoleQuery.first().then(function(adminRole) {
    if (adminRole) {
      return Promise.resolve(true);
    } else return Promise.resolve(false);
  });
}

function requireAdmin(to, from, next) {
  if (Parse.User.current()) {
    isAdmin().then((isAdmin) => {
      if (isAdmin) {
        next();
      } else {
        next({
          path: '/',
        });
      }
    });
  } else {
    next({
      path: '/',
    });
  }
}
